import { render, staticRenderFns } from "./DesktopAd.vue?vue&type=template&id=6c0b48a8&scoped=true"
import script from "./DesktopAd.vue?vue&type=script&lang=js"
export * from "./DesktopAd.vue?vue&type=script&lang=js"
import style0 from "./DesktopAd.vue?vue&type=style&index=0&id=6c0b48a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b48a8",
  null
  
)

export default component.exports